<template>
  <div class="banner-home" >
    <div class="mouse-wrapper"  @mouseenter="onBlur(true)" @mouseleave="onBlur(false)"></div>
    <!--    <swiper ref="mySwiper" :options="config" class="z-swiper">-->
    <!--      <template v-for="item in filteredBannerList" >-->
    <!--        <swiper-slide> <img :src="item.imgUrl" @click="onClickSlider(item)"/></swiper-slide>-->
    <!--      </template>-->
    <!--    </swiper>-->
<!--        <div-->
<!--        class="z-swiper swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events">-->
    <div class="z-swiper" @mouseenter="onBlur(true)" @mouseleave="onBlur(false)">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in filteredBannerList" :data-i="index" :data-url="item.jumpUrl" :key="index">
          <div>
            <img :src="item.imgUrl" :url="item.jumpUrl" :data-id="item.id"/>
          </div>
        </div>
      </div>
    </div>
    <div v-show="arrowShow && filteredBannerList.length>3 && !isMobile"
         @mouseenter="onBlur(true)" @mouseleave="onBlur(false)" class="swiper-btn swiper-button-prev">
      <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.672 6.99999L0.722 2.04999L2.136 0.635986L8.5 6.99999L2.136 13.364L0.722 11.95L5.672 6.99999Z" fill="#4A4A68"/>
      </svg>
    </div>
    <div v-show="arrowShow && filteredBannerList.length>3 && !isMobile"
         @mouseenter="onBlur(true)" @mouseleave="onBlur(false)"
         class="swiper-btn swiper-button-next">
      <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.672 6.99999L0.722 2.04999L2.136 0.635986L8.5 6.99999L2.136 13.364L0.722 11.95L5.672 6.99999Z" fill="#4A4A68"/>
      </svg>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import {uniswapHomwBannerList} from '~/model/clientSwapModel';
  // import Swiper from 'libDir/plugins/swiper6_4/swiper-bundle.min.js';
  // require('libDir/plugins/swiper6_4/swiper-bundle.min.css');
  // import Swiper JS
  import Swiper from 'swiper/bundle';
  // import Swiper styles
  import 'swiper/swiper-bundle.css';
  import $ from 'jquery';
  import _ from 'lodash';
import { isMobile } from '~/utils/util'
  export default {
    name: 'home_banner',
    // components: {
    //   swiper,
    //   swiperSlide
    // },
    data () {
      return {
        swiper: null,
        timerHandler: null,
        progress: 0,
        fps: 120,
        delay: 4000,
        activeIndex: 0,
        showProgress: false,
        bannerList: [],
        arrowShow: false,
        config: {
           slidesPerView: 'auto',
           spaceBetween: 24,
           slidesPerGroup: 1,
          // autoplay: {
          //   pauseOnMouseEnter: true,
          //   delay: 4000,
          //   stopOnLastSlide: false,
          //   disableOnInteraction: false
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      };
    },
    watch: {
      filteredLocal (val) {
        this.loadData();
      }
    },
    computed: {
      ...mapState({
        locale: state => state.common.locale,
        mainLocales: state => state.common.mainLocales
      }),
      filteredLocal () {
        return this.locale === 'pt-br' ? 'pt' : this.mainLocales.includes(this.locale) ? this.locale : 'en';
      },
      filteredBannerList () {
        return this.bannerList;
      }
    },
    async mounted () {
      await this.loadData();
      this.$nextTick(() => {
        if (this.filteredBannerList.length > 3) {
          this.config.autoplay = {
            pauseOnMouseEnter: true,
              delay: 4000,
              stopOnLastSlide: false,
              disableOnInteraction: false
          };
          this.config.loop = true;
        }
        let swiper = new Swiper('.z-swiper', this.config);
        swiper.on('click', this.onClickSlider);
      });
    },
    destroyed () {
      if (this.timerhandler) {
        clearInterval(this.timerhandler);
        this.timerhandler = null;
      }
    },
    methods: {
      onClickSlider (swiper, e) {
        let id = parseInt($(e.target).attr('data-id'));
        let item = _.find(this.filteredBannerList, {id: id});
        if (item) {
          if (item.jumpUrl.indexOf('https://www.bitforex.com/') !== -1) {
            window.location.href = item.jumpUrl;
          } else {
            window.open( item.jumpUrl);
          }
        }
      },
      onBlur (value) {
        this.isMobile = isMobile()
        if (this.filteredBannerList.length <= 3) {
          return;
        }
        this.arrowShow = value;
      },
      async loadData () {
        let result = (await uniswapHomwBannerList({languageType: this.filteredLocal === 'kr' ? 'ko' : this.filteredLocal}));
        if (result.success) {
          let oriList = result.data;
          let sortList = oriList.sort((a, b) => {
            return a.sortNum - b.sortNum;
          });
          this.bannerList = sortList;
        //    this.bannerList = [
        //     {
        //         id: '3316',
        //         imgUrl: 'https://statics.bitforex.vip/2cfee6b7-cbbc-4bb1-8af0-5fd0cc7404ec.png',
        //         jumpUrl: ''
        //     },
        //     {
        //         id: '3231',
        //         imgUrl: 'https://statics.bitforex.vip/f0f72af9-73ae-48f1-a8ad-cf590999e554.png',
        //         jumpUrl: ''
        //     },
        //     {
        //         id: '3171',
        //         imgUrl: 'https://statics.bitforex.vip/52878bd7-8739-4d15-bed1-0da8a77a0114.png',
        //         jumpUrl: ''
        //     },
        //     {
        //         id: '3298',
        //         imgUrl: 'https://statics.bitforex.vip/aa2bac1a-1a2d-412e-9db1-43784369c8b9.png',
        //         jumpUrl: ''
        //     },
        //     {
        //         id: '3153',
        //         imgUrl: 'https://statics.bitforex.vip/81467605-e32c-454c-ba19-947e62842f2d.png',
        //         jumpUrl: ''
        //     },
        //     {
        //         id: '3255',
        //         imgUrl: 'https://statics.bitforex.vip/f6179d02-cf54-4fd0-9a33-b5efee976de4.png',
        //         jumpUrl: ''
        //     },
        //     {
        //         id: '3285',
        //         imgUrl: 'https://statics.bitforex.vip/ddf88632-b6ef-4178-90f0-1d75f413161c.png',
        //         jumpUrl: ''
        //     }
        // ]
        }
      },
      go (url) {
        this.$router.push(url);
      },
      slideChange (swiper) {
        if (!swiper.animating) {
          this.activeIndex = swiper.realIndex + 1;
        }
      }
    }
  };
</script>

<style scoped lang="scss">


  /*.banner-home {*/
  /*  user-select: none;*/
  /*  .z-swiper {*/
  /*    width: 100%;*/
  /*    .swiper-wrapper {*/
  /*    }*/
  /*    .swiper-slide {*/
  /*      position: relative;*/
  /*      img {*/
  /*        user-select: none;*/
  /*        object-fit: cover;*/
  /*        display: block*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/
  .banner-home {
    width: 1200px;
    margin: 20px auto;
    position: relative;

    .mouse-wrapper {
      position: absolute;
      height: 100%;
      left: -100px;
      right: -100px;
    }

    .z-swiper {
    overflow: hidden;
    }

    .swiper-slide /deep/ {
      width: 282px;
      height: 140px;
      cursor: pointer;
      border-radius: 6px;
      overflow: hidden;

      img {
        width: 282px;
        height: 140px;
        object-fit: contain;
        border-radius: 6px;
      }
    }

    .swiper-btn {
      position: absolute;
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: #FFFFFF;
      /*opacity: 0.2;*/
      border: 1px solid #FFFFFF;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15), 0px 4px 8px rgba(0, 0, 0, 0.2);
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-top: calc(0px - (var(--swiper-navigation-size) / 2)) !important;

      svg {
        width: 15px;
        height: 15px;
      }

      &:after {
        content: unset;
      }
    }

    .swiper-button-prev {
      left: -16px;
      transform:rotate(180deg);
      &:hover {
        background: #F7F8FA;
      }
    }

    .swiper-button-next {
      right: -16px;
      &:hover {
        background: #F7F8FA;
      }
    }
  }
  @media screen and (max-width: 1199px) {
    .banner-home{
      width: 100%;
    }
    .swiper-button-prev {
      left: 10px !important;
      transform:rotate(180deg);
    }

    .swiper-button-next {
      right: 10px !important;
    }
  }

</style>
